export class Breakeven {
    startDate: Date;
    endDate: Date;
    amount: number;
    days: number;
}
